exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".json-editor[data-v-b570e220]{border:1px solid #ccc;border-radius:5px}\n", ""]);

